'use strict';

const _=require('pulsar-utils/dist-es6/_');
const GenerateEnum=require('pulsar-utils/dist-es6/domain/generateEnum');
const FatigueMeterType=GenerateEnum(['Workforce','Trucking','Aviation'],'FatigueMeterType');

module.exports=FatigueMeterType;
//# sourceMappingURL=fatigueMeterType.js.map
